var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKfcPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 50,
    viewBox: "0 0 55 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5245 0.270264H47.4757C51.1545 0.270264 54.1342 3.12142 54.1342 6.64157V20.9611C54.1342 23.2404 52.8591 25.3477 50.7917 26.485L26.9208 39.6067L4.09868 26.5041C2.0928 25.3525 0.865967 23.2786 0.865967 21.0407V6.64157C0.865967 3.12142 3.84566 0.270264 7.5245 0.270264Z",
    fill: "#F1F9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1038 48.626H46.3374",
    stroke: "#393F52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3034 28.7938V27.4717L27.6851 23.5056V22.1836M40.1199 28.7938V27.4717L36.6658 23.5056V22.1836L40.1199 28.7938ZM33.2117 28.7938V27.4717L31.83 23.5056V22.1836L33.2117 28.7938ZM19.3936 28.7938V27.4717L22.8493 23.5056V22.1836L19.3936 28.7938Z",
    stroke: "#BCC0C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2649 29.4548V48.6261",
    stroke: "#393F52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3938 22.1836H40.1201V17.5564H19.3938V22.1836Z",
    fill: "#E9EAEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3938 22.1836H40.1201V17.5564H19.3938V22.1836Z",
    stroke: "#393F52"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4854 28.7938V32.7599C12.4854 34.4738 14.15 36.065 15.9395 36.065C17.7289 36.065 19.3936 34.4738 19.3936 32.7599C19.3936 34.4738 21.0582 36.065 22.8494 36.065C24.6372 36.065 26.3035 34.4738 26.3035 32.7599C26.3035 34.4738 27.9681 36.065 29.7576 36.065C31.5471 36.065 33.2117 34.4738 33.2117 32.7599C33.2117 34.4738 34.8763 36.065 36.6658 36.065C38.4553 36.065 40.1199 34.4738 40.1199 32.7599C40.1199 34.4738 41.7846 36.065 43.574 36.065C45.3635 36.065 47.0282 34.4738 47.0282 32.7599V28.7938H12.487H12.4854Z",
    fill: "#E9EAEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4854 28.7938V32.7599C12.4854 34.4738 14.15 36.065 15.9395 36.065C17.7289 36.065 19.3936 34.4738 19.3936 32.7599C19.3936 34.4738 21.0582 36.065 22.8494 36.065C24.6372 36.065 26.3035 34.4738 26.3035 32.7599C26.3035 34.4738 27.9681 36.065 29.7576 36.065C31.5471 36.065 33.2117 34.4738 33.2117 32.7599C33.2117 34.4738 34.8763 36.065 36.6658 36.065C38.4553 36.065 40.1199 34.4738 40.1199 32.7599C40.1199 34.4738 41.7846 36.065 43.574 36.065C45.3635 36.065 47.0282 34.4738 47.0282 32.7599V28.7938H12.487H12.4854Z",
    stroke: "#393F52"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1199 22.1835H19.3936L12.4854 27.2312V28.7938H47.0282V27.2312L40.1199 22.1835Z",
    stroke: "#393F52"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1201 31.4379V32.7599M19.3938 31.4379V32.7599V31.4379ZM26.3037 31.4379V32.7599V31.4379ZM33.2119 31.4379V32.7599V31.4379Z",
    stroke: "#393F52",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72203 48.626H6.95874",
    stroke: "#393F52"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4262 48.626C14.7325 41.0155 22.3549 39.1169 22.3549 32.8794C22.3549 28.1057 17.9969 24.3036 12.8798 24.9184C8.50679 25.4457 5.27574 29.2445 5.60034 33.4512C6.04646 39.2411 13.2077 41.2529 13.5057 48.626H14.4262Z",
    fill: "#E4002B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4262 48.626C14.7325 41.0155 22.3549 39.1169 22.3549 32.8794C22.3549 28.1057 17.9969 24.3036 12.8798 24.9184C8.50679 25.4457 5.27574 29.2445 5.60034 33.4512C6.04646 39.2411 13.2077 41.2529 13.5057 48.626H14.4262Z",
    stroke: "#FFEBEF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6303 32.7647C16.6303 34.2269 15.3935 35.412 13.8671 35.412C12.3406 35.412 11.1038 34.2269 11.1038 32.7647C11.1038 31.3009 12.3406 30.1158 13.8671 30.1158C15.3935 30.1158 16.6303 31.3009 16.6303 32.7647Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5772 48.6261H4.19556M16.6304 32.7647C16.6304 34.2269 15.3935 35.412 13.8671 35.412C12.3406 35.412 11.1038 34.2269 11.1038 32.7647C11.1038 31.3009 12.3406 30.1158 13.8671 30.1158C15.3935 30.1158 16.6304 31.3009 16.6304 32.7647Z",
    stroke: "#393F52"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9026 48.6261H40.8108V39.3701H33.9026V48.6261Z",
    fill: "#E9EAEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9026 48.6261H40.8108V39.3701H33.9026V48.6261Z",
    stroke: "#393F52"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8496 45.3209H31.1395V39.3701H22.8496V45.3209Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0284 48.6261H48.4101M22.8496 45.3209H31.1395V39.3701H22.8496V45.3209Z",
    stroke: "#393F52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKfcPin);
export default __webpack_public_path__ + "static/media/kfc-pin.dbfeab507b2398f9b0998294c976dd80.svg";
export { ForwardRef as ReactComponent };